// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_y4HeB","secondaryColumnCell":"secondary-column-cell_y4HeB","title":"title_DJCBp","item":"item_JAo0t","button":"button_l7Tz2"};